import { AppInjector } from './'

let appInjectorRef: AppInjector

export const appInjectorInstance = (injector?: AppInjector): AppInjector => {
  if (injector) {
    appInjectorRef = injector
  }

  return appInjectorRef
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/helpers/app-injector/app-injector-instance.ts